import { useEffect } from "react";

declare global {
  interface Window {
    DB?: DB;
  }
}

// DB is only to be used in homepages (calculators), injected by tracking scripts in sitecore
interface DB {
  trackCalculatorLoad: (props: {
    calculator_type: string;
    calculator_name: string;
    calculator_amount: number;
  }) => void;
  trackCalculatorInit: () => void;
  trackCalculatorSubmit: (amount?: string, info?: string) => void;
  track: (id: string) => void;
}

export function useTrackCalculatorLoad(name: string, amount = 0) {
  useEffect(() => {
    if (window.DB && window.DB.trackCalculatorLoad) {

      window.DB.trackCalculatorLoad({
        'calculator_type': "insurance",
        'calculator_name': name,
        'calculator_amount': amount,
      });
    }
  }, []);
}

export function trackCalculatorSubmit(amount?: string, info?: string) {
  if (window.DB && window.DB.trackCalculatorSubmit) {
    window.DB.trackCalculatorSubmit(amount, info);
  }
}

export function trackCalculatorInit() {
  if (window.DB && window.DB.trackCalculatorInit) {
    window.DB.trackCalculatorInit();
  }
}

export function track(id: string) {
  if (window.DB && window.DB.track) {
    window.DB.track(id);
  }
}
